import React, {useContext, useEffect} from 'react'
import {mountPage} from './mountPage'
import Header from '../components/header/Header'
import OnBoarding from '../components/onBoarding/OnBoarding'
import {ApplicationWrapperContext} from '../components/common/ApplicationWrapper/ApplicationWrapperContext'

const SignIn = () => {
  const {isUserLogged} = useContext(ApplicationWrapperContext)
  useEffect(() => {
    if (isUserLogged) window.location.href = window.location.origin
  }, [isUserLogged])
  return (
    <>
      <header className="tl-auth-header">
        <Header showLinks={false} showUserMenu={false} />
        <nav className="tl-auth-menu" aria-label="Public navigation">
          <a href="/">Home</a>
          <a href="/about">About Us</a>
          <a href="/system">How It Works</a>
          <a className="tl-auth-menu__signin" href="/signin" aria-current="page">
            Sign In
          </a>
        </nav>
      </header>
      <div className="signin-page">
        <div className="signin-bg">
          <section className="tl-auth-hero" aria-label="About TranslionCAT">
            <span className="tl-auth-hero__mark" aria-hidden="true" />
            <p className="tl-auth-hero__brand">TranslionCAT</p>
            <h1>Translation technology for professionals</h1>
            <p className="tl-auth-hero__text">
              One workspace for analysis, CAT translation, AutoTranslate,
              Claude QA and document templates.
            </p>
          </section>
        </div>
        <div className="signin-overlay">
          <div className="signin-content">
            <OnBoarding />
          </div>
        </div>
      </div>
    </>
  )
}

export default SignIn

mountPage({
  Component: SignIn,
  rootElement: document.getElementsByClassName('signin__page')[0],
})
